import React, { useState, useEffect } from 'react';
import { Navbar, Nav, Container, Button } from 'react-bootstrap';
import { useNavigate, useLocation } from 'react-router-dom';

const Header = ({ onShowInterest }) => {
  const navigate = useNavigate();  
  const location = useLocation(); 
  const [activeSection, setActiveSection] = useState('');
  const [expanded, setExpanded] = useState(false);

  // (keep existing scroll‑spy useEffect – it only runs on pages with sections)

  const handleNavClick = (e, target) => {
    e.preventDefault();

    // Try to find the element on the current page
    const element = document.getElementById(target);

    if (element) {
      // Same page – smooth scroll
      const offsetTop = element.offsetTop - 120;
      window.scrollTo({ top: offsetTop, behavior: 'smooth' });
      setActiveSection(target);
    } else {
      // Different page – navigate to home and pass the target as state
      navigate('/', { state: { scrollTo: target } });
    }

    setExpanded(false); // close mobile menu
  };

  // Handle logo click (go home + scroll to top)
  const handleLogoClick = (e) => {
    e.preventDefault();
    if (location.pathname !== '/') {
      navigate('/');
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
    setExpanded(false);
  };

  return (
    <div className="header-wrapper">
      <div className="header-container">
        <Navbar expand="lg" className="header-navbar" expanded={expanded} onToggle={setExpanded}>
          <Container fluid className="px-4">
            <Navbar.Brand href="/" onClick={handleLogoClick} className="d-flex align-items-center">
              <img src="/images/logo.png" alt="Nisa Care Logo" className="header-logo" />
            </Navbar.Brand>

            <Navbar.Toggle aria-controls="navbar-nav" />
            <Navbar.Collapse id="navbar-nav">
              <Nav className="mx-auto align-items-center gap-4">
                <Nav.Link
                  href="#features"
                  className={`nav-link-custom ${activeSection === 'features' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'features')}
                >
                  Features
                </Nav.Link>
                <Nav.Link
                  href="#how-it-works"
                  className={`nav-link-custom ${activeSection === 'how-it-works' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'how-it-works')}
                >
                  How it works
                </Nav.Link>
                <Nav.Link
                  href="#community"
                  className={`nav-link-custom ${activeSection === 'community' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'community')}
                >
                  Community
                </Nav.Link>
                <Nav.Link
                  href="#mission"
                  className={`nav-link-custom ${activeSection === 'mission' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'mission')}
                >
                  Mission
                </Nav.Link>
                <Nav.Link
                  href="#faq"
                  className={`nav-link-custom ${activeSection === 'faq' ? 'active' : ''}`}
                  onClick={(e) => handleNavClick(e, 'faq')}
                >
                  FAQ
                </Nav.Link>
              </Nav>

              <Button className="show-interest-btn" onClick={onShowInterest}>
                Show interest
              </Button>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </div>
    </div>
  );
};

export default Header;